export default __webpack_public_path__ + "static/media/cmp-perks-hand.6a1e288e.png";